import type {Representative} from "@project/application/sales/representatives";

import {getRepresentativeQueryOptions} from "@project/application/sales/representatives";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {RepresentativePage} from "./-page/representative.page";
import {RepresentativePending} from "./-page/representative.pending";

const representativeSearchSchema = z.object({
  includeDeleted: z.boolean().default(false),
});

export const Route = createFileRoute("/_app/sales/representatives/$representativeId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: representativeSearchSchema,
  loaderDeps: ({search}) => ({includeDeleted: search.includeDeleted}),
  loader: async ({context: {queryClient}, deps, params}) =>
    queryClient.ensureQueryData(
      getRepresentativeQueryOptions(params.representativeId, deps.includeDeleted),
    ),
  pendingComponent: RepresentativePending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) =>
        (data as Representative | undefined)?.company.companyName,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.representativeById.id,
        values: {representativeId: p["representativeId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {representativeId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <RepresentativePage includeDeleted={includeDeleted} representativeId={representativeId} />;
}
